import { defineMessages } from "react-intl";

export const giftCardSettingsExpirySelectMessages = defineMessages({
  setExpirationPeriodTitle: {
    id: "j2l6cL",
    defaultMessage: "Set gift card expiration period",
    description: "checkbox label",
  },
  setExpirationPeriodDescription: {
    id: "ps+h1G",
    defaultMessage:
      "Expiration date will be automatically set, once gift card is issued",
    description: "checkbox label description",
  },
});
